export const FileIcon = ({
  className,
  styles,
}: {
  className?: string;
  styles?: any;
}) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    style={styles}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      opacity="0.3"
      d="M11.7143 4H27.4728C28.1822 4 28.8686 4.25137 29.4102 4.70948L38.9374 12.7679C39.6113 13.3379 40 14.1758 40 15.0584V40.1667C40 43.7478 39.9591 44 36.2857 44H11.7143C8.0409 44 8 43.7478 8 40.1667V7.83333C8 4.25225 8.0409 4 11.7143 4Z"
      fill="currentColor"
    />
    <path
      d="M28 22H14C12.8954 22 12 22.8954 12 24C12 25.1046 12.8954 26 14 26H28C29.1046 26 30 25.1046 30 24C30 22.8954 29.1046 22 28 22Z"
      fill="currentColor"
    />
    <path
      d="M20 30H14C12.8954 30 12 30.8954 12 32C12 33.1046 12.8954 34 14 34H20C21.1046 34 22 33.1046 22 32C22 30.8954 21.1046 30 20 30Z"
      fill="currentColor"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3914_317"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4B83EE" />
        <stop offset="1" stopColor="#3266E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3914_317"
        x1="21"
        y1="22"
        x2="21"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4B83EE" />
        <stop offset="1" stopColor="#3266E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3914_317"
        x1="17"
        y1="30"
        x2="17"
        y2="34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4B83EE" />
        <stop offset="1" stopColor="#3266E2" />
      </linearGradient>
    </defs>
  </svg>
);
